/* web/style.css .type-pop / .type-row / .type-toggle */
.pop { width: 320px; padding: 6px; overflow-y: auto; overscroll-behavior: contain; }
.row { position: relative; display: grid; grid-template-columns: 1fr auto auto; align-items: center; }
.toggle { display: flex; align-items: center; gap: 10px; width: 100%; min-width: 0; border: 0; background: transparent; padding: 9px 10px; border-radius: 10px; text-align: left; font-size: 15px; -webkit-touch-callout: none; user-select: none; }
.toggle:hover, .toggle:focus-visible { background: var(--fill); }
.all { font-weight: 600; border-bottom: 1px solid var(--line-soft); border-radius: 10px 10px 0 0; margin-bottom: 4px; }
.emoji { width: 24px; display: flex; justify-content: center; font-size: 18px; line-height: 1; flex: none; }
.star { color: var(--starred); }
.name { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.count { color: var(--muted); font-size: 13px; font-variant-numeric: tabular-nums; }
.check { width: 18px; color: var(--accent); flex: none; }
.check :global(.icon), .level :global(.icon) { width: 18px; height: 18px; }
.level { flex: none; color: var(--muted); }
.hidden .name { color: var(--muted); }
